export default __webpack_public_path__ + "static/media/truck-02.54f31f5d.jpg";